import supportModule from '../supportModule';

function chatLaunch(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.chatLaunch
  };
}

supportModule.directive('chatLaunch', chatLaunch);

export default chatLaunch;
